module.exports = __webpack_public_path__ + "static/img/homecard_company.aa538de9.jpg";